module.exports = __webpack_public_path__ + "img/Dominos_pizza_logo.b3209d77.svg";